<template>
  <div class="company-card" :class="vertical ? 'vertical' : ''" v-if="company.id">
    <div class="company-card__profile-image" v-if="profilePicture">
      <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=" class="company-card__profile-image" alt="img" :style="'display: inline-block; width: ' + (profilePictureSize.includes('px') ? profilePictureSize : profilePictureSize + 'px') + '; height: ' + (profilePictureSize.includes('px') ? profilePictureSize : profilePictureSize + 'px') + '; background-image: url(' + (company.logo || 'https://www.gravatar.com/avatar/default?s=' + profilePictureSize.replaceAll('px', '') + '&r=pg&d=mm') + ');'" />
    </div>
    <div class="company-card__profile-data">
      <h5>
        <b-link :to="{name: routeName, params: {id: company.id}}">#{{company.id}}</b-link>
        {{company.name}}
      </h5>
      <h6><small>({{company.business_name}})</small></h6>
      <dl class="mb-0">
        <dt v-if="withTin && withTitles" v-translate>TIN</dt>
        <dd v-if="withTin">{{company.tin}}</dd>

        <div v-if="withContact">
          <dt v-if="withTitles" v-translate>Contact</dt>
          <dd v-if="company.contact_name">
            {{company.contact_name}}
          </dd>

          <dt v-if="withTitles" v-translate>Email</dt>
          <dd v-if="company.email">
            <a :href="'mailto:' + company.email">{{company.email}}</a>
            <a v-b-tooltip.html href="#" @click.prevent="copyToClipboard(company.email, 'email')" class="text-secondary" :title="this.$gettext('Copy to Clipboard')">
              <font-awesome-icon :icon="['far', 'copy']" size="1x" />
            </a>
          </dd>
          <dd class="text-danger" v-else><strong v-translate>NO EMAIL!!?? 😕</strong></dd>

          <dt v-if="withTitles" v-translate>Phone</dt>
          <dd v-if="company.phone">
            <span class="d-inline-block" v-b-tooltip.bottom.html :title="phoneActions">
              {{company.phone | phone('ar')}}
            </span>
            <a v-b-tooltip.html href="#" @click.prevent="copyToClipboard(company.phone, 'phone')" class="text-secondary" :title="this.$gettext('Copy to Clipboard')">
              <font-awesome-icon :icon="['far', 'copy']" size="1x" />
            </a>
          </dd>
          <dd class="text-danger" v-else><strong v-translate>NO PHONE! 😕</strong></dd>
        </div>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompanyCard',
  props: {
    company: {
      type: Object,
      default: () => {
        return {}
      }
    },
    withTin: {
      type: Boolean,
      default: false
    },
    withContact: {
      type: Boolean,
      default: true
    },
    profilePicture: {
      type: Boolean,
      default: true
    },
    profilePictureSize: {
      type: [String, Number],
      default: '80px'
    },
    withTitles: {
      type: Boolean,
      default: true
    },
    vertical: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    phoneActions() {
      return '<div class="m-2 text-nowrap"><a class="btn btn-sm btn-secondary" style="padding: 0.1rem 1rem;" href="tel:' + this.company.phone + '">' + this.$gettext('Call') + '</a>&nbsp;<a class="btn btn-sm btn-secondary" style="padding: 0.1rem 1rem;" v-if="company.phone" href="' + this.$options.filters.whatsappize(this.company.phone) + '">WhatsApp</a></div>'
    }
  },
  data() {
    return {
      routeName: 'CompaniesEdit'
    }
  },
  mounted() {
    if (this.ecosystemModules.carriers && this.company.relationship === 'provider') {
      this.routeName = 'CarriersEdit'
    } else if (this.ecosystemModules.customers && this.company.relationship === 'client') {
      this.routeName = 'CustomersEdit'
    } else {
      this.routeName = 'CompaniesEdit'
    }
  }
}
</script>

<style lang="scss" scoped>
.company-card {
  display: flex;
  &.vertical {
    flex-direction: column;
    .company-card__profile-image {
      padding-right: 0;
      padding-bottom: 15px;
      text-align: center;
    }
  }
  &__profile-image {
    background: transparent no-repeat 50% 50%/cover;
    padding-right: 15px;
  }
  &__profile-data {
    flex: 1 1 auto;
    h5 {
      font-weight: 400;
      white-space: nowrap;
      margin-bottom: 0;
    }
    dl {
      font-size: .8rem;
    }
    dt {
      width: 70px;
      font-weight: 400;
      float: left;
    }
    dd {
      font-weight: 400;
      margin: 0;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
  &__profile-phone {
    background: transparent;
    border: 0;
  }
}
</style>
